import { Typography, Divider, Stack } from '@mui/material';

export default function PrivacyPolicyDe() {
  return (
    <Stack spacing={3}>
      <Typography variant="h4" fontWeight={700}>
        BRITESTAGE – Datenschutzerklärung
      </Typography>
      <Typography variant="body2" color="text.secondary">
        <strong>Version 1.0</strong>
        <br />
        Letzte Aktualisierung: 13. April 2026
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        1. Allgemeine Informationen
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        1.1 Verantwortlicher
      </Typography>
      <Typography variant="body1">Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</Typography>
      <Typography variant="body1">
        <strong>21Minds GmbH</strong>
        <br />
        Botnanger Str. 6
        <br />
        70193 Stuttgart
        <br />
        Deutschland
        <br />
        (&bdquo;BRITESTAGE&ldquo;, &bdquo;wir&ldquo;, &bdquo;uns&ldquo;)
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        1.2 Geltungsbereich dieser Datenschutzerklärung
      </Typography>
      <Typography variant="body1">
        Diese Datenschutzerklärung informiert Sie über die Verarbeitung personenbezogener Daten im Zusammenhang mit:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>der Nutzung der BRITESTAGE-Plattform,</li>
          <li>der Erstellung und Verwaltung von Benutzerkonten,</li>
          <li>der Teilnahme an Veranstaltungen und Kooperationen,</li>
          <li>Marktplatz-Interaktionen zwischen Nutzern und Organisationen,</li>
          <li>Kommunikations- und Supportdiensten sowie</li>
          <li>allen damit verbundenen Online-Diensten.</li>
        </ul>
      </Typography>
      <Typography variant="body1">Sie gilt für alle Nutzer der Plattform, unabhängig davon, ob sie als:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Einzelnutzer,</li>
          <li>Mitwirkende (z. B. Referenten, Diskussionsteilnehmer),</li>
          <li>Mitglieder von Organisationen oder</li>
          <li>Veranstalter handeln.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        1.3 Rechtlicher Rahmen
      </Typography>
      <Typography variant="body1">Die Verarbeitung personenbezogener Daten erfolgt in Übereinstimmung mit:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>der Datenschutz-Grundverordnung (DSGVO),</li>
          <li>den geltenden nationalen Datenschutzgesetzen und</li>
          <li>sonstigen einschlägigen Rechtsvorschriften.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        1.4 Begriffsbestimmungen
      </Typography>
      <Typography variant="body1">
        &bdquo;Personenbezogene Daten&ldquo; sind alle Informationen, die sich auf eine identifizierte oder
        identifizierbare natürliche Person beziehen.
      </Typography>
      <Typography variant="body1">
        &bdquo;Verarbeitung&ldquo; ist jeder Vorgang im Zusammenhang mit personenbezogenen Daten, wie z. B. Erhebung,
        Speicherung, Nutzung, Offenlegung oder Löschung.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        2. Datenschutzrechtliche Rollen und Verantwortlichkeiten
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        2.1 BRITESTAGE als Verantwortlicher
      </Typography>
      <Typography variant="body1">
        BRITESTAGE handelt als <strong>eigenständiger Verantwortlicher</strong>, soweit es die Zwecke und Mittel der
        Verarbeitung festlegt, insbesondere für:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Kontoregistrierung und -verwaltung,</li>
          <li>Plattformbetrieb und -sicherheit,</li>
          <li>Profilsichtbarkeit und Ranking-Systeme,</li>
          <li>Marktplatzfunktionen,</li>
          <li>Abrechnung und Abonnementverwaltung sowie</li>
          <li>KI-gestützte Plattformfunktionen.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        2.2 BRITESTAGE als Auftragsverarbeiter
      </Typography>
      <Typography variant="body1">
        Soweit Nutzer im Auftrag von Organisationen handeln (z. B. Veranstalter), kann BRITESTAGE personenbezogene Daten{' '}
        <strong>im Auftrag dieser Organisationen</strong> verarbeiten.
      </Typography>
      <Typography variant="body1">In diesen Fällen:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>handelt die Organisation als Verantwortlicher,</li>
          <li>handelt BRITESTAGE als Auftragsverarbeiter,</li>
          <li>
            wird die Verarbeitung durch einen <strong>Auftragsverarbeitungsvertrag (Art. 28 DSGVO)</strong> geregelt.
          </li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        2.3 Eigenständige Verantwortliche
      </Typography>
      <Typography variant="body1">
        Bestimmte Dritte (z. B. Zahlungsdienstleister) handeln als <strong>eigenständige Verantwortliche</strong>. Deren
        Verarbeitung unterliegt ihren eigenen Datenschutzerklärungen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        2.4 Keine gemeinsame Verantwortlichkeit
      </Typography>
      <Typography variant="body1">
        Sofern nicht ausdrücklich anders angegeben, handelt BRITESTAGE nicht als gemeinsam Verantwortlicher mit Nutzern
        oder Organisationen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        3. Kategorien personenbezogener Daten
      </Typography>
      <Typography variant="body1">
        Je nach Nutzung der Plattform verarbeiten wir die folgenden Kategorien personenbezogener Daten:
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.1 Konto- und Profildaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Name, E-Mail-Adresse, Kontaktdaten</li>
          <li>Profilinformationen (beruflicher Hintergrund, Fähigkeiten, Biografie)</li>
          <li>Profilbilder und hochgeladene Inhalte</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.2 Authentifizierungsdaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Anmeldedaten (verarbeitet über Authentifizierungsanbieter)</li>
          <li>Sitzungsdaten und Authentifizierungstoken</li>
          <li>Anmeldeverlauf und Geräteinformationen</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.3 Veranstaltungs- und Beitragsdaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Veranstaltungsteilnahmedaten</li>
          <li>Beiträge (z. B. Sessions, Materialien, Kommentare)</li>
          <li>Kollaborationsdaten innerhalb von Veranstaltungen</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.4 Marktplatz- und Transaktionsdaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Buchungs- und Beauftragungsdaten</li>
          <li>Vertragsbezogene Informationen zwischen Nutzern und Organisationen</li>
          <li>Zahlungsbezogene Metadaten</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.5 Technische und Nutzungsdaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>IP-Adressen</li>
          <li>Protokolldaten</li>
          <li>Geräte- und Browserinformationen</li>
          <li>Nutzungsmuster und Interaktionen</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.6 Kommunikationsdaten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Supportanfragen</li>
          <li>Über die Plattform ausgetauschte Nachrichten</li>
          <li>Benachrichtigungen und Korrespondenz</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        3.7 KI-generierte und -verarbeitete Daten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Eingaben in KI-gestützte Funktionen</li>
          <li>Generierte Zusammenfassungen, Empfehlungen und Inhalte</li>
          <li>Interaktionsdaten zur Verbesserung der Funktionalität</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        4. Zwecke der Verarbeitung und Rechtsgrundlagen
      </Typography>
      <Typography variant="body1">Wir verarbeiten personenbezogene Daten zu folgenden Zwecken:</Typography>

      <Typography variant="h6" fontWeight={600}>
        4.1 Bereitstellung und Betrieb der Plattform
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Bereitstellung von Benutzerkonten und Plattformfunktionen</li>
          <li>Veranstaltungsmanagement und Zusammenarbeit</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.2 Plattformsicherheit und -integrität
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Verhinderung von Betrug und Missbrauch</li>
          <li>Schutz von Systemen und Nutzern</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.3 Profilsichtbarkeit und professionelles Networking
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Anzeige von Nutzerprofilen</li>
          <li>Matching zwischen Mitwirkenden und Veranstaltern</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. a DSGVO (bei optionaler
        Sichtbarkeit)
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.4 Bewertungs- und Ranking-Systeme
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Anzeige und Berechnung von Bewertungen</li>
          <li>Matching- und Empfehlungsalgorithmen</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
        Plattformfunktionalität)
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.5 Marktplatz und Transaktionen
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Vermittlung von Beauftragungen</li>
          <li>Abwicklung von Zahlungen</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.6 KI-gestützte Funktionen
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Inhaltserstellung und Empfehlungen</li>
          <li>Veranstaltungsunterstützungsfunktionen</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO
      </Typography>
      <Typography variant="body1">
        Eine automatisierte Entscheidungsfindung mit rechtlicher Wirkung findet nicht statt.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.7 Kommunikation und Support
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Beantwortung von Anfragen</li>
          <li>Bereitstellung von Support</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO; Art. 6 Abs. 1 lit. f DSGVO
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        4.8 Rechtliche Compliance
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Erfüllung gesetzlicher Pflichten</li>
          <li>Aufbewahrung von Aufzeichnungen</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. c DSGVO
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        5. Datenquellen
      </Typography>
      <Typography variant="body1">Wir erheben personenbezogene Daten aus folgenden Quellen:</Typography>

      <Typography variant="h6" fontWeight={600}>
        5.1 Von Nutzern bereitgestellte Daten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Registrierungsdaten</li>
          <li>Profilinformationen</li>
          <li>Hochgeladene Inhalte</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        5.2 Durch die Nutzung erzeugte Daten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Nutzungsdaten</li>
          <li>Interaktionsdaten</li>
          <li>Veranstaltungsteilnahmedaten</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        5.3 Daten von Organisationen
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Von Veranstaltern oder Arbeitgebern bereitgestellte Daten</li>
          <li>Mitwirkendenzuweisungen</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        5.4 Daten von Dritten
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Authentifizierungsanbieter</li>
          <li>Zahlungsdienstleister</li>
          <li>Technische Dienstleister</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        6. Datenspeicherung
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        6.1 Allgemeine Aufbewahrungsgrundsätze
      </Typography>
      <Typography variant="body1">
        Personenbezogene Daten werden nur so lange gespeichert, wie es erforderlich ist, um:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die in dieser Datenschutzerklärung genannten Zwecke zu erfüllen,</li>
          <li>gesetzliche Pflichten einzuhalten,</li>
          <li>Streitigkeiten beizulegen und Vereinbarungen durchzusetzen.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        6.2 Kontodaten
      </Typography>
      <Typography variant="body1">
        Benutzerkontodaten werden für die Dauer des Kontos aufbewahrt. Bei Löschung:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>werden Daten innerhalb von maximal drei (3) Monaten gelöscht,</li>
          <li>sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        6.3 Veranstaltungs- und Beitragsdaten
      </Typography>
      <Typography variant="body1">
        Bestimmte Daten (z. B. Beiträge zu Veranstaltungen) können auch nach Kontolöschung im Veranstaltungskontext
        bestehen bleiben, soweit dies erforderlich ist für:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die Integrität der Veranstaltungsdokumentation,</li>
          <li>berechtigte Interessen der Veranstalter.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        6.4 Gesetzliche Aufbewahrungspflichten
      </Typography>
      <Typography variant="body1">
        Daten können länger aufbewahrt werden, soweit gesetzlich vorgeschrieben, insbesondere:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>handels- und steuerrechtliche Aufbewahrungspflichten,</li>
          <li>Prüfungs- und Compliance-Anforderungen.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        6.5 Technische Daten
      </Typography>
      <Typography variant="body1">
        Protokolldaten werden für begrenzte Zeiträume aufbewahrt, die erforderlich sind für:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Sicherheit,</li>
          <li>Fehlerbehebung,</li>
          <li>Systemoptimierung.</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        7. Datenverarbeitung durch Dritte
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        7.1 Allgemeine Informationen
      </Typography>
      <Typography variant="body1">
        Um die BRITESTAGE-Plattform bereitzustellen, zu betreiben, zu sichern und zu verbessern, setzen wir ausgewählte
        Drittanbieter ein.
      </Typography>
      <Typography variant="body1">Je nach Kontext der Verarbeitung können diese Dritten handeln als:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Auftragsverarbeiter (Art. 28 DSGVO)</strong>, die personenbezogene Daten ausschließlich in unserem
            Auftrag und nach unseren Weisungen verarbeiten, oder
          </li>
          <li>
            <strong>Eigenständige Verantwortliche (Art. 4 Nr. 7 DSGVO)</strong>, die Daten zu eigenen Zwecken
            verarbeiten.
          </li>
        </ul>
      </Typography>
      <Typography variant="body1">
        Soweit Dienstleister als Auftragsverarbeiter handeln, stellen wir sicher, dass:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            ein <strong>Auftragsverarbeitungsvertrag (Art. 28 DSGVO)</strong> geschlossen wird,
          </li>
          <li>
            die Verarbeitung auf <strong>dokumentierte Weisungen</strong> beschränkt ist,
          </li>
          <li>
            angemessene <strong>technische und organisatorische Maßnahmen (TOMs)</strong> umgesetzt werden und
          </li>
          <li>Vertraulichkeits- und Sicherheitspflichten vertraglich gewährleistet sind.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        7.2 Unterauftragsverarbeiter
      </Typography>
      <Typography variant="body1">
        Für die Bereitstellung und den Betrieb der Plattform setzt BRITESTAGE sorgfältig ausgewählte Drittanbieter
        (&bdquo;Unterauftragsverarbeiter&ldquo;) ein, die personenbezogene Daten in unserem Auftrag verarbeiten.
      </Typography>
      <Typography variant="body1">
        Soweit diese Verarbeitung als Auftragsverarbeitung qualifiziert, werden Unterauftragsverarbeiter gemäß{' '}
        <strong>Art. 28 DSGVO</strong> eingesetzt und vertraglich verpflichtet:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>personenbezogene Daten nur auf dokumentierte Weisung zu verarbeiten,</li>
          <li>Vertraulichkeit zu gewährleisten,</li>
          <li>angemessene technische und organisatorische Maßnahmen umzusetzen und</li>
          <li>BRITESTAGE bei der Erfüllung gesetzlicher Pflichten zu unterstützen.</li>
        </ul>
      </Typography>

      <Typography variant="body1">
        Die aktuellen Unterauftragsverarbeiter von BRITESTAGE sind nachfolgend aufgeführt:
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        Microsoft Azure (Hosting &amp; Infrastruktur)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> Microsoft Ireland Operations Ltd., Dublin, Irland
          </li>
          <li>
            <strong>Dienst:</strong> Cloud-Infrastruktur (Hosting, Speicher, Netzwerk)
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Alle Plattformdaten, einschließlich Nutzerdaten, Inhalte und technische
            Protokolle
          </li>
          <li>
            <strong>Zweck:</strong> Hosting und Betrieb der Plattform
          </li>
          <li>
            <strong>Verarbeitungsort:</strong> Europäische Union
          </li>
          <li>
            <strong>Schutzmaßnahmen:</strong> Verschlüsselung, Zugriffskontrollen, ISO-zertifizierte Infrastruktur
          </li>
        </ul>
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        MongoDB Atlas (Datenbank-Hosting)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> MongoDB, Inc. (EU-Einheit: MongoDB Limited, Irland)
          </li>
          <li>
            <strong>Dienst:</strong> Verwaltete Datenbankdienste
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Strukturierte Anwendungsdaten (Konten, Profile, Veranstaltungsdaten,
            Inhalte)
          </li>
          <li>
            <strong>Zweck:</strong> Datenspeicherung und -abruf
          </li>
          <li>
            <strong>Verarbeitungsort:</strong> Europäische Union
          </li>
          <li>
            <strong>Schutzmaßnahmen:</strong> Verschlüsselung, rollenbasierter Zugriff, Audit-Protokollierung
          </li>
        </ul>
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        Clerk (Authentifizierung &amp; Identitätsverwaltung)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> Clerk, Inc., Vereinigte Staaten
          </li>
          <li>
            <strong>Dienst:</strong> Authentifizierung, Sitzungs- und Identitätsverwaltung
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Anmeldedaten, E-Mail-Adressen, Sitzungsdaten,
            Authentifizierungsmetadaten
          </li>
          <li>
            <strong>Zweck:</strong> Sichere Benutzerauthentifizierung und Kontoschutz
          </li>
          <li>
            <strong>Verarbeitungsort:</strong> Vereinigte Staaten
          </li>
          <li>
            <strong>Schutzmaßnahmen:</strong> Verschlüsselung, sichere Token-Verarbeitung, Zugriffsbeschränkungen
          </li>
        </ul>
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        Lexware (Rechnungsstellung &amp; Buchhaltung)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> Haufe-Lexware GmbH &amp; Co. KG, Munzinger Straße 9, 79111 Freiburg, Deutschland
          </li>
          <li>
            <strong>Dienst:</strong> Software für Rechnungsstellung, Buchhaltung und Finanzverwaltung
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Rechnungsdaten (Namen, Adressen, E-Mail-Adressen), Transaktionsdaten
            (Rechnungen, Zahlungsstatus, Beträge), steuerrelevante Informationen
          </li>
          <li>
            <strong>Zweck:</strong> Erstellung und Verwaltung von Rechnungen, Buchhaltung und Finanzberichterstattung,
            Einhaltung steuer- und handelsrechtlicher Pflichten
          </li>
          <li>
            <strong>Verarbeitungsort:</strong> Deutschland / Europäische Union
          </li>
          <li>
            <strong>Schutzmaßnahmen:</strong> Zugriffskontrollen und Authentifizierung, Datenverschlüsselung soweit
            anwendbar, Einhaltung deutscher Buchhaltungs- und Datenschutzstandards
          </li>
        </ul>
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        LiveKit (Echtzeit-Video- und Audiokommunikation)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> LiveKit, Inc., 2261 Market Street #4098, San Francisco, CA 94114, USA
          </li>
          <li>
            <strong>Dienst:</strong> Echtzeit-Kommunikationsinfrastruktur für Video-, Audio- und Datenstreaming
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Audio- und Videostreams, Echtzeit-Kommunikationsmetadaten (Zeitstempel,
            Sitzungskennungen), technische Daten (IP-Adressen, Verbindungsdaten)
          </li>
          <li>
            <strong>Zweck:</strong> Ermöglichung von Live-Video- und Audioübertragungen während Veranstaltungen,
            Unterstützung interaktiver Kommunikationsfunktionen
          </li>
          <li>
            <strong>Verarbeitungsort:</strong> Europäische Union und globale Infrastruktur
          </li>
          <li>
            <strong>Übermittlungsmechanismus:</strong> EU-Standardvertragsklauseln (SCCs)
          </li>
          <li>
            <strong>Schutzmaßnahmen:</strong> Transportverschlüsselung, sichere Übertragungsprotokolle,
            Zugriffsbeschränkungen und sitzungsbasierte Isolation
          </li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        7.3 Dritte als eigenständige Verantwortliche
      </Typography>
      <Typography variant="body1">
        Bestimmte in die Plattform integrierte Dienste werden von Dritten erbracht, die personenbezogene Daten zu
        eigenen Zwecken verarbeiten und als eigenständige Verantwortliche handeln. In diesen Fällen hat BRITESTAGE keine
        Kontrolle über die Verarbeitungstätigkeiten dieser Anbieter.
      </Typography>

      <Typography variant="subtitle1" fontWeight={600}>
        Mollie (Zahlungsabwicklung)
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            <strong>Anbieter:</strong> Mollie B.V., Amsterdam, Niederlande
          </li>
          <li>
            <strong>Dienst:</strong> Zahlungsabwicklung
          </li>
          <li>
            <strong>Verarbeitete Daten:</strong> Zahlungs- und Rechnungsdaten, Transaktionsmetadaten, begrenzte
            personenbezogene Daten
          </li>
          <li>
            <strong>Zweck:</strong> Durchführung von Zahlungen, Betrugsprävention, rechtliche Compliance
          </li>
          <li>
            <strong>Rolle:</strong> Eigenständiger Verantwortlicher
          </li>
        </ul>
      </Typography>
      <Typography variant="body1">Weitere Informationen finden Sie in der Datenschutzerklärung von Mollie.</Typography>

      <Typography variant="h6" fontWeight={600}>
        7.4 Internationale Datenübermittlungen
      </Typography>
      <Typography variant="body1">
        Soweit personenbezogene Daten in Länder außerhalb des Europäischen Wirtschaftsraums (EWR) übermittelt werden,
        stellt BRITESTAGE sicher, dass diese Übermittlungen mit <strong>Art. 44 ff. DSGVO</strong> übereinstimmen.
      </Typography>
      <Typography variant="body1">Insbesondere stützen wir uns auf folgende Schutzmaßnahmen:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>EU-Standardvertragsklauseln (SCCs),</li>
          <li>Zusätzliche technische und organisatorische Maßnahmen,</li>
          <li>Angemessenheitsbeschlüsse, soweit anwendbar (z. B. EU-U.S. Datenschutzrahmen).</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        7.5 Änderungen bei Unterauftragsverarbeitern
      </Typography>
      <Typography variant="body1">
        BRITESTAGE kann Unterauftragsverarbeiter von Zeit zu Zeit aktualisieren oder ersetzen, soweit dies aus
        betrieblichen, technischen oder rechtlichen Gründen erforderlich ist. Soweit gesetzlich vorgeschrieben, werden
        Nutzer vorab über wesentliche Änderungen informiert.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        7.6 Widerspruchsrecht bei Unterauftragsverarbeitern (Enterprise-Bestimmung)
      </Typography>
      <Typography variant="body1">
        Soweit BRITESTAGE personenbezogene Daten im Auftrag von Organisationen verarbeitet, können diese Organisationen
        das Recht haben, der Beauftragung neuer Unterauftragsverarbeiter zu widersprechen.
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>BRITESTAGE wird vorab informieren (in der Regel mindestens 15 Tage).</li>
          <li>Kunden können aus berechtigten Datenschutzgründen widersprechen.</li>
          <li>
            Bei berechtigtem Widerspruch wird BRITESTAGE eine Alternative anbieten, soweit möglich, oder die Kündigung
            der betroffenen Dienste ermöglichen.
          </li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        8. Datenweitergabe und Offenlegung
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        8.1 Allgemeine Grundsätze
      </Typography>
      <Typography variant="body1">Personenbezogene Daten werden nur an Dritte weitergegeben, wenn:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>dies für die Bereitstellung der Plattform erforderlich ist,</li>
          <li>eine gesetzliche Pflicht dazu besteht oder</li>
          <li>der Nutzer seine Einwilligung erteilt hat.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        8.2 Weitergabe an Organisationen
      </Typography>
      <Typography variant="body1">
        Soweit Nutzer an Veranstaltungen teilnehmen oder im Auftrag von Organisationen handeln:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>können relevante personenbezogene Daten an die jeweilige Organisation weitergegeben werden,</li>
          <li>dies umfasst Profildaten, Beitragsdaten und veranstaltungsbezogene Informationen,</li>
          <li>die Organisation handelt für diese Verarbeitung als eigenständiger Verantwortlicher.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        8.3 Weitergabe an andere Nutzer
      </Typography>
      <Typography variant="body1">
        Je nach Plattformfunktionalität und Sichtbarkeitseinstellungen können personenbezogene Daten für andere Nutzer
        sichtbar sein, darunter:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Profilinformationen,</li>
          <li>Beiträge und Veranstaltungsteilnahme,</li>
          <li>Bewertungen und Feedback.</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        Die Sichtbarkeit wird, soweit zutreffend, durch Nutzereinstellungen gesteuert.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        8.4 Weitergabe an Dienstleister
      </Typography>
      <Typography variant="body1">
        Personenbezogene Daten werden gemäß Abschnitt 7 (Unterauftragsverarbeiter) an Dienstleister weitergegeben.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        8.5 Weitergabe aus rechtlichen Gründen
      </Typography>
      <Typography variant="body1">
        Wir können personenbezogene Daten offenlegen, soweit dies erforderlich ist, um:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>gesetzliche Pflichten zu erfüllen,</li>
          <li>Rechtsansprüche durchzusetzen,</li>
          <li>Betrug oder Missbrauch zu verhindern,</li>
          <li>die Rechte, das Eigentum oder die Sicherheit von Nutzern oder Dritten zu schützen.</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        9. Betroffenenrechte
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.1 Übersicht
      </Typography>
      <Typography variant="body1">Nutzer haben folgende Rechte nach der DSGVO:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Auskunftsrecht (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.2 Auskunftsrecht
      </Typography>
      <Typography variant="body1">
        Nutzer können eine Bestätigung darüber verlangen, ob personenbezogene Daten verarbeitet werden, und eine Kopie
        dieser Daten erhalten.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.3 Recht auf Berichtigung
      </Typography>
      <Typography variant="body1">
        Nutzer können die Berichtigung unrichtiger oder unvollständiger Daten verlangen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.4 Recht auf Löschung
      </Typography>
      <Typography variant="body1">Nutzer können die Löschung ihrer Daten verlangen, wenn:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die Daten nicht mehr erforderlich sind,</li>
          <li>die Einwilligung widerrufen wird,</li>
          <li>die Verarbeitung unrechtmäßig ist oder</li>
          <li>gesetzliche Pflichten die Löschung erfordern.</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.5 Recht auf Einschränkung
      </Typography>
      <Typography variant="body1">
        Nutzer können unter bestimmten Voraussetzungen die Einschränkung der Verarbeitung verlangen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.6 Recht auf Datenübertragbarkeit
      </Typography>
      <Typography variant="body1">
        Nutzer können verlangen, ihre Daten in einem strukturierten, gängigen Format zu erhalten.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.7 Widerspruchsrecht
      </Typography>
      <Typography variant="body1">
        Nutzer können der Verarbeitung auf Grundlage berechtigter Interessen widersprechen. In diesem Fall wird die
        Verarbeitung eingestellt, sofern keine zwingenden berechtigten Gründe vorliegen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        9.8 Ausübung der Rechte
      </Typography>
      <Typography variant="body1">
        Anfragen können über die in Abschnitt 14 angegebenen Kontaktdaten eingereicht werden.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        10. Recht auf Widerruf der Einwilligung
      </Typography>
      <Typography variant="body1">
        Soweit die Verarbeitung auf einer Einwilligung beruht (Art. 6 Abs. 1 lit. a DSGVO), haben Nutzer das Recht, die
        Einwilligung jederzeit zu widerrufen. Der Widerruf berührt nicht die Rechtmäßigkeit der Verarbeitung vor dem
        Widerruf.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        11. Automatisierte Entscheidungsfindung
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        11.1 Keine automatisierten Entscheidungen mit rechtlicher Wirkung
      </Typography>
      <Typography variant="body1">
        BRITESTAGE führt keine automatisierte Entscheidungsfindung im Sinne von Art. 22 DSGVO durch, die rechtliche
        Wirkung entfaltet oder den Nutzer in ähnlicher Weise erheblich beeinträchtigt.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        11.2 KI-gestützte Funktionen
      </Typography>
      <Typography variant="body1">Die Plattform nutzt KI-gestützte Systeme, um:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Empfehlungen zu generieren,</li>
          <li>das Veranstaltungsmanagement zu unterstützen,</li>
          <li>bei der Inhaltserstellung zu assistieren.</li>
        </ul>
      </Typography>
      <Typography variant="body1">Diese Systeme:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>ersetzen keine menschliche Entscheidungsfindung,</li>
          <li>erzeugen keine verbindlichen Ergebnisse,</li>
          <li>dienen ausschließlich als Hilfswerkzeuge.</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        12. Cookies und Tracking-Technologien
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        12.1 Allgemeine Informationen
      </Typography>
      <Typography variant="body1">
        BRITESTAGE verwendet Cookies und ähnliche Technologien, um die Funktionalität und Sicherheit der Plattform
        sicherzustellen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        12.2 Arten von Cookies
      </Typography>
      <Typography variant="body1">
        <strong>Essentielle Cookies:</strong> Für den Plattformbetrieb erforderlich; ermöglichen Authentifizierung und
        Sitzungsverwaltung.
      </Typography>
      <Typography variant="body1">
        <strong>Funktionale Cookies:</strong> Verbessern die Benutzerfreundlichkeit; speichern Einstellungen.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        12.3 Kein Marketing-Tracking (aktueller Stand)
      </Typography>
      <Typography variant="body1">Derzeit verwendet BRITESTAGE keine:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Werbe-Cookies von Drittanbietern,</li>
          <li>Cross-Site-Tracking-Technologien.</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        Dies kann sich in Zukunft ändern und wird in dieser Datenschutzerklärung entsprechend aktualisiert.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        12.4 Rechtsgrundlage
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Essentielle Cookies: Art. 6 Abs. 1 lit. b DSGVO</li>
          <li>Optionale Cookies: Art. 6 Abs. 1 lit. a DSGVO (soweit anwendbar)</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        13. Datensicherheit
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        13.1 Allgemeine Maßnahmen
      </Typography>
      <Typography variant="body1">
        BRITESTAGE implementiert angemessene technische und organisatorische Maßnahmen zum Schutz personenbezogener
        Daten.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        13.2 Sicherheitsmaßnahmen umfassen
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Verschlüsselung bei der Übertragung und im Ruhezustand</li>
          <li>Zugriffskontrollen und Authentifizierungsmechanismen</li>
          <li>Sichere Cloud-Infrastruktur</li>
          <li>Überwachung und Protokollierung</li>
        </ul>
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        13.3 Keine absolute Sicherheit
      </Typography>
      <Typography variant="body1">
        Trotz angemessener Maßnahmen kann kein System absolute Sicherheit garantieren.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        14. Kontakt und Aufsichtsbehörde
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        14.1 Kontakt
      </Typography>
      <Typography variant="body1">Für alle datenschutzrechtlichen Anfragen wenden Sie sich bitte an:</Typography>
      <Typography variant="body1">
        21Minds GmbH
        <br />
        Botnanger Str. 6
        <br />
        70193 Stuttgart
        <br />
        Deutschland
        <br />
        E-Mail: privacy@britestage.com
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        14.2 Datenschutzbeauftragter
      </Typography>
      <Typography variant="body1">
        Ein Datenschutzbeauftragter wurde bestellt, soweit dies gesetzlich vorgeschrieben ist. Sofern bestellt, werden
        die Kontaktdaten hier veröffentlicht.
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        14.3 Aufsichtsbehörde
      </Typography>
      <Typography variant="body1">
        Nutzer haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren. Die zuständige Behörde in Deutschland ist
        in der Regel:
      </Typography>
      <Typography variant="body1">
        Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg
      </Typography>

      <Typography variant="h6" fontWeight={600}>
        14.4 Alternative Behörden
      </Typography>
      <Typography variant="body1">
        Nutzer können sich auch an die Aufsichtsbehörde ihres Wohnsitzes innerhalb der EU wenden.
      </Typography>
    </Stack>
  );
}
